import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function Broadcast() {
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [listRecipient, setListRecipient] = useState([
    { label: "Seluruh Element", value: "all" },
    { label: "Seluruh Anggota", value: "anggota" },
    { label: "Spesifik Anggota", value: "spesifik" }
  ]);
  const [listUser, setListUser] = useState([]);
  const [recipient, setRecipient] = useState();
  const [newData, setNewData] = useState({
    recipient_type: "",
    title: "",
    body: "",
    user_recipient: "",
  });
  const [isLoading, setIsLoading] = useState(true);


  // CONTROLLER
  const fetchDataAnggota = async () => {
    setIsLoading(true);
    await baseAPI
      .get(`/v1/user`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.userData;

        let listUser = [];
        data.forEach(e => {
          if (e.status != 0) {
            listUser.push({ label: e.name_anggota + " (" + e.npp_anggota + ")", value: e.id })
          }
        });
        setListUser(listUser);
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  const storeNotification = (sender) => {
    Swal.fire({
      title: 'Are you sure to send this notification?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Send',
      denyButtonText: `Don't send`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));
        body.append('sender', sender);

        baseAPI
          .post(`/v1/notification`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Notification has been sent.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed send the notification.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false)
            fetchDataAnggota();
          })
      } else if (result.isDenied) {
        Swal.fire('Notification is not sent', '', 'info')
      }
    });
  }

  useEffect(() => {
    setIsLoading(true);
    fetchDataAnggota()
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <Link to='/broadcast' style={{ color: '#333' }}>Broadcast</Link>
          </ol>
        </div>
      </div>
    </div>
  );

  const sendView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Broadcast</b></p>
              </div>

              {/* Opsi Penerima */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Penerima
                </label>
                <Select
                  options={listRecipient}
                  isSearchable
                  // defaultValue={listRecipient && recipient}
                  placeholder="Pilih penerima"
                  onChange={e => {
                    setRecipient(e.value)
                    setNewData({...newData, recipient_type: e.value});
                  }}
                />
              </div>

              {/* Judul Notifikasi */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Judul Notifikasi
                </label>
                <input
                  className="form-control"
                  placeholder="Judul notifikasi"
                  onChange={e => setNewData({...newData, title: e.target.value})}
                />
              </div>
              
              {/* jika memilih mengirim ke spesifik user (multiple or single) */}
              {recipient === "spesifik" 
              ? 
                <div className='col-md-6 mb-3'>
                  <label htmlFor='true' className='form-label'>
                    Spesifik Anggota Penerima
                  </label>
                  <Select
                    options={listUser}
                    isMulti
                    isSearchable
                    placeholder="Pilih spesifik anggota penerima"
                    onChange={e => {
                      setNewData({...newData, user_recipient: e});
                    }}
                  />
                </div>
              : <div className='col-md-6 mb-3'></div>}

              {/* Body Notifikasi */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Isi Notifikasi
                </label>
                <textarea
                  className="form-control"
                  placeholder="Tuliskan body notifikasi disini..."
                  onChange={e => setNewData({...newData, body: e.target.value})}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={newData.recipient !== "" && newData.title !== "" && newData.body !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => storeNotification(user.role)}
                >
                  Send
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}

      {isLoading ? <LoadingView /> : sendView()}

    </div>
  );

}

export default Broadcast;